export default {
      id: "sli-home-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.43681d49.svg#sli-home",
      toString: function () {
        return this.url;
      }
    }